import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'admForget';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function postForgetPassword(dataSlice) {
  dataSlice.dataUrl.code="POST_ADM_PORTAL_FORGET";
  return _createEntityService(dataSlice,events);
}

export function postChangePassword(dataSlice) {
  dataSlice.dataUrl.code="POST_ADM_PORTAL_CHANGEPSW";
  return _createEntityService(dataSlice,events);
}